import {
    Target, Heart, Shield, Users, Lightbulb, Globe,
    Code, ShieldCheck, BarChart, Gem, UserStar
} from 'lucide-react';

// Team Images
import Jonas from "../../assets/Images_site_myriade/Konuste_jonas.jpeg";
import Kahar from "../../assets/Images_site_myriade/Idrissou_kahar.jpeg";
import Kalvin from "../../assets/Images_site_myriade/Takoudjou_kalvin.jpeg";
import Catherine from "../../assets/Images_site_myriade/Massoule_catherine.jpeg";
import Herve from "../../assets/Images_site_myriade/Binto_herve.jpeg";
import Theo from "../../assets/Images_site_myriade/Baite_theo.jpeg";


// Company Values Data
export const values = [
    {
        icon: Target,
        title: "Excellence",
        description: "Nous visons l'excellence dans chaque projet, en fournissant des solutions de qualité supérieure qui dépassent les attentes.",
        color: "from-blue-500 to-cyan-500"
    },
    {
        icon: Heart,
        title: "Engagement",
        description: "Notre engagement envers nos clients est total. Nous sommes dévoués à leur succès et à leur satisfaction continue.",
        color: "from-red-500 to-pink-500"
    },
    {
        icon: Shield,
        title: "Intégrité",
        description: "Nous agissons avec honnêteté et transparence dans toutes nos relations commerciales.",
        color: "from-emerald-500 to-green-500"
    },
    {
        icon: Users,
        title: "Collaboration",
        description: "Nous croyons en la puissance du travail d'équipe et de la collaboration pour atteindre des résultats exceptionnels.",
        color: "from-purple-500 to-violet-500"
    },
    {
        icon: Lightbulb,
        title: "Innovation",
        description: "Nous repoussons constamment les limites de l'innovation pour offrir des solutions avant-gardistes.",
        color: "from-amber-500 to-orange-500"
    },
    {
        icon: Globe,
        title: "Impact",
        description: "Nous nous engageons à créer un impact positif sur la société et l'environnement grâce à la technologie.",
        color: "from-cyan-500 to-blue-500"
    }
];

// Team Members Data (not including CEO and Technical Lead - they have their own sections)
export const teamMembers = [

    // {
    //     id: 1,
    //     name: "Jonas KONUTSE",
    //     role: "Directeur Général",
    //     expertise: "Full Stack & IA",
    //     experience: "10+ ans",
    //     description: "Spécialiste en développement d'applications complexes et intégration d'intelligence artificielle.",
    //     photo: Jonas,
    //     icon: Code,
    //     projects: 15,
    // },
    // {
    //     id: 2,
    //     name: "Kahar IDRISSOU",
    //     role: "Responsable Technique et Cybersécurité",
    //     expertise: "Cybersécurité & Pentests",
    //     experience: "10+ ans",
    //     description: "Experte en sécurité informatique avec certification CISSP et spécialisation en tests d'intrusion.",
    //     photo: Kahar,
    //     icon: ShieldCheck,
    //     projects: 15,
    // },
    {
        id: 1,
        name: "Kalvin Takoudjou",
        role: "Developpeur Full Stack",
        expertise: "Developpeur Full Stack",
        experience: "02+ ans",
        description: "Developpement et conception d'application web et mobile à la pointe de la technologie.",
        photo: Kalvin,
        icon: UserStar,
        projects: 10,
    },
    {
        id: 2,
        name: "Catherine Meheza",
        role: "Secretaire",
        expertise: "Secrétaire de direction",
        experience: "05+ ans",
        description: "Secrétaire d'entreprise avec une solide expérience dans la gestion administrative et organisationnelle.",
        photo: Catherine,
        icon: Gem,
        projects: 10,
    },
    {
        id: 3,
        name: "Herve Bito",
        role: "UI/UX Designer",
        expertise: "UI/UX Designer",
        experience: "03+ ans",
        description: "Designer et Graphiste avec une solide expérience dans la conception et la création d'interfaces utilisateur.",
        photo: Herve,
        icon: BarChart,
        projects: 10,
    },
    {
        id: 4,
        name: "Theophile Baite",
        role: "Developpeur Web",
        expertise: "Developpement web",
        experience: "02+ ans",
        description: "Developpeur avec une solide expérience dans le developpement web.",
        photo: Theo,
        icon: Code,
        projects: 10,
    },
];

// CEO Data
export const ceoData = {
    name: "Jonas KONUTSE",
    role: "Directeur Général",
    expertise: "Full Stack & IA",
    experience: "10+ ans",
    description: "Spécialiste en développement d'applications complexes et intégration d'intelligence artificielle. Visionnaire technologique avec une expertise approfondie en transformation digitale et innovation.",
    photo: Jonas,
    projects: 15,
};

// Technical Lead Data
export const technicalLeadData = {
    name: "Kahar IDRISSOU",
    role: "Responsable Technique & Cybersécurité",
    expertise: "Cybersécurité & Pentests",
    experience: "10+ ans",
    description: "Expert en sécurité informatique avec certification CISSP et spécialisation en tests d'intrusion. Leader technique garantissant la robustesse et la sécurité de toutes nos solutions.",
    photo: Kahar,
    projects: 15,
};
